export default __webpack_public_path__ + "static/media/WhiteClockLight.23076f16.png";